<template>
  <div style="margin:20px">
    <div v-if="!standalone" style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Vehicle Status Manager</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        latest status for all vehicles, status can be manually updated using the dropdown
        <span style="float:right; font-weight: bold; font-size: 18px;"><b-button variant="success" size="sm" @click="view_more_info = !view_more_info"><b>more info</b></b-button></span>
      </div>
    </div>
    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;Vehicle Status Manager&nbsp;
      <b-spinner v-if="reloading" style="width: 1.8rem; height: 1.8rem"></b-spinner><span v-else style="width: 1.8rem; height: 1.8rem">&nbsp;</span>
      </span>
    </div>

    <b-modal title="Here are details on the statuses and filters used for the VSM" size="xl" v-model="view_more_info" ok-only>
      <br/>
      <h4>Vehicle Status</h4>

      <span v-if="washed_enabled">
        &nbsp;&nbsp;READY - automatically set by the system when a vehicle has been cleaned and washed and is ready for service
        <br/>&nbsp;&nbsp;CLEANED - indicates that the vehicle interior has been cleaned (manually managed)
        <br/>&nbsp;&nbsp;WASHED - indicates that the vehicle exterior has been washed (manually managed)
      </span>
      <span v-else>
        &nbsp;&nbsp;CLEANED - indicates that the vehicle has been cleaned (manually managed)
      </span>
      <br/>&nbsp;&nbsp;DIRTY - automatically set by the system when a vehicle arrives back to the finish location or yard
      <br/>&nbsp;&nbsp;OUT - automatically set by the system when a vehicle leaves the start location for a planned booking
      <br/>&nbsp;&nbsp;OOS - out of service (manually managed)
      <br><hr/>
      <h4>VSM Standalone Mode</h4>
      &nbsp;&nbsp;provides a standalone view that refreshes every minute to keep all teams in sync (no login required)
      <br/>&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-tbn/reload/' + this.tenant_id">click here to load this view</a>
      <span v-if="base_options.length > 2">
        <br/><br/>&nbsp;&nbsp;Click on a base name to load the VSM specific to that base.<br/>
        <span v-if="base.value != ''" v-for="base in base_options">
          <br/>&nbsp;&nbsp;&nbsp;<a target="_blank" :href="'./#/vsm-tbn/reload/' + tenant_id + '/' + base.value">{{base.value}}</a>
        </span>
      </span>
      <br><hr/>
      <span v-if="summary && summary.aws_phone_number">
        <h4>Update Status & Notes Over SMS</h4>
        &nbsp;&nbsp;simply send a text in one of the following formats: to #{{summary.aws_phone_number | prettyPhoneNumber}}<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the status only, send '[status] [vehicle name]' - for example 'cleaned 123'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the notes only, send 'notes [vehicle name], [notes]' - for example 'notes 123, issue found'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to update the status & notes, send '[status] [vehicle name], [notes]' - for example 'cleaned 123, issue found'<br>
        &nbsp;&nbsp;&nbsp;&nbsp;to clear notes, send '[notes] [vehicle name]' - for example 'notes 123'
      </span>
    </b-modal>

    <b-modal title="Add Record" size="md" v-model="show_add_vehicle_info_modal" ok-only>
      <div>
        Vehicle Name: <b-form-input v-model="add_vehicle_info_model.name" required/>
        Base: <b-form-input v-model="add_vehicle_info_model.start_base" required/>
        Notes: <b-form-input v-model="add_vehicle_info_model.notes" required/>
        Next Scheduled Time: <datetime style="margin: 5px;border-radius: 5px;" format="MM/DD/YYYY H:i" :value="add_vehicle_info_model.next_scheduled_time" @input="add_vehicle_info_model.next_scheduled_time=$event"/>
      </div>
      <br/>
      <b-button v-if="!loading" variant="success" size="md" @click="add_vehicle_info_record()">Save</b-button>
    </b-modal>

    <div v-if="!loading">
      <div class="row" style="margin: 20px 0px 25px 0px; font-weight: bold; font-size: 20px;">
        <div @click="filter_by_status(null)" :style="selected_vehicle_statuses.length === 0 ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col total" style="width: 250px; border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_statuses.includes('ready') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Ready-{{ready_cnt}}</div>
        <div @click="filter_by_status('cleaned')" :style="selected_vehicle_statuses.includes('cleaned') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Clean-{{clean_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_statuses.includes('washed') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Washed-{{washed_cnt}}</div>
        <div @click="filter_by_status('dirty')" :style="selected_vehicle_statuses.includes('dirty') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Dirty-{{dirty_cnt}}</div>
        <div @click="filter_by_status('out')" :style="selected_vehicle_statuses.includes('out') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">Out-{{out_cnt}}</div>
        <div @click="filter_by_status('oos')" :style="selected_vehicle_statuses.includes('oos') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos">OOS-{{oos_cnt}}</div>
        <div v-if="base_options && base_options.length > 2" class="col" style="border: none"><b-form-select v-model="selected_base" :options="base_options" style="font-size: 20px; font-weight: bold; width:200px"/></div>
        <div v-if="vehicle_tag_options && vehicle_tag_options.length > 2" class="col" style="border: none"><b-form-select v-model="selected_vehicle_tag" :options="vehicle_tag_options" style="font-size: 20px; font-weight: bold; width:200px"/></div>
        <div class="col d-flex align-items-center justify-content-center" style="border: none"><b-form-input style="font-size: 20px; font-weight: bold; width: 200px" v-model="search_filter" placeholder="filter by keyword"/></div>
        <div class="d-flex align-items-center justify-content-center">
          <b-btn size="sm" @click="load_data()"><span style="font-size: 18px; font-weight: bold">Reload</span></b-btn>
          <span v-if="!standalone && summary.include_vehicle_info_only_enabled">
            &nbsp;&nbsp;<b-btn size="sm" @click="show_add_vehicle_info_modal = !show_add_vehicle_info_modal"><span style="font-size: 20px; font-weight: bold;">Add</span></b-btn>
          </span>
          &nbsp;&nbsp;<span @click="printPage()"><img height="30px" src="/print-icon.png"/></span>
        </div>
      </div>
    </div>

    <div v-if="summary">
      <b-table :busy="loading" :sticky-header="!standalone ? '70vh' : false" bordered :items="items" :fields="visibleFields" :tbody-tr-class="get_row_color"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="notes" slot-scope="row">
          <div v-if="!standalone" class="d-flex align-items-center justify-content-center">
            <b-form-input :style="'font-size:' + summary.font_size + 'px; min-width:200px'" v-model="row.item.notes" :disabled="updating" v-on:blur="update_notes(row, row.item)"/>
          </div>
          <div style="text-align: left" v-else>{{row.item.notes}}</div>
        </template>
        
        <template slot="vehicle_status" slot-scope="row">
          <span v-if="row.item.future_booking">
            FUTURE
          </span>
          <span v-else>
            <b-form-select v-if="standalone && (summary.visible_update_fields && summary.visible_update_fields.indexOf('username') == -1)" :style="'font-size:' + summary.font_size + 'px'" v-model="row.item.vehicle_status" :options="status_options" @change="add_new_status_record(row, row.item)"/>
            <b-form-select v-else-if="!standalone" :style="'font-size:' + summary.font_size + 'px'" v-model="row.item.vehicle_status" :options="status_options" @change="update_vehicle_status(row, row.item)"/>
            <span v-else>{{row.item.vehicle_status}}</span>
          </span>
        </template>

        <template slot="current_mvmt_id" slot-scope="row">
          <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + row.item.current_mvmt_booking_hash }">{{ row.item.current_mvmt_id }}</router-link>
        </template>

        <template slot="last_fueled_time" slot-scope="row">
            {{row.item.last_fueled_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="last_gps_time" slot-scope="row">
          {{row.item.last_gps_time | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="processed_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_dirty_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_dirty_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_oos_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_oos_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="dump_date" slot-scope="row">
            {{row.item.dump_date | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="detailed_date" slot-scope="row">
          {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
        </template>

        <template slot="last_returned_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_cleaned_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_cleaned_number" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_cleaned_number}}
          </span>
        </template>

        <template slot="last_washed_time" slot-scope="row">
          <span v-if="row.item.vehicle_info" :style="row.item.last_washed_delta ? 'color:red' : ''">
              {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="last_washed_number" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_washed_number}}
          </span>
        </template>

        <template slot="next_mvmt_driver" slot-scope="row">
          {{row.item.next_mvmt_driver | trim(14)}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_driver | trim(14)}}
          </template>

        </template>

        <template slot="last_ready_time" slot-scope="row">
          <span v-if="row.item.vehicle_info">
            {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
          </span>
        </template>

        <template slot="next_mvmt_start_base" slot-scope="row">
          {{row.item.next_mvmt_start_base}}&nbsp;
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_start_base}}&nbsp;
          </template>
        </template>

        <template slot="next_scheduled_time" slot-scope="row">
          <div v-if="!standalone">
            <datetime @click="row.toggleDetails();" style="margin: 5px;border-radius: 5px;" format="MM/DD/YYYY H:i" v-model="row.item.next_scheduled_time"  @input="update_vehicle_status(row, row.item)"/>
          </div>
          <div v-else>
            {{row.item.next_scheduled_time | formatDateTimeCustom(summary.datetime_format)}}
          </div>
        </template>
        
        <template slot="next_mvmt_driver_start" slot-scope="row">
          {{row.item.next_mvmt_driver_start | convert24HrDateTimeSmall(summary.datetime_format)}}
        </template>

        <template slot="next_mvmt_time" slot-scope="row">
          {{row.item.next_mvmt_time | convert24HrDateTimeSmall(summary.datetime_format)}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_time}}
          </template>
        </template>

        <template slot="next_mvmt_id" slot-scope="row">
          {{row.item.next_mvmt_id}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_id}}
          </template>
        </template>

        <template slot="next_mvmt_delta" slot-scope="row">
          <span v-if="row.item.next_mvmt_delta" :style="row.item.next_mvmt_delta.indexOf('d') != -1 ? '' : 'color: red'">
            {{row.item.next_mvmt_delta}}
          </span>
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_delta}}
          </template>
        </template>

        <template slot="update_status" slot-scope="row">
          <b-button size="lg" style="margin: 10px" @click="row.toggleDetails(); updating = !updating">
            Update Status
          </b-button>
        </template>

        <template slot="delete" slot-scope="row">
          <div style="font-weight: bold; color: darkred; padding:3px" @click="delete_status_record(row, row.item)">X</div>
        </template>

        <template slot="details" slot-scope="row">
          <span v-if="row.item.future_booking">&nbsp;</span>
          <b-button v-else-if="standalone && summary.visible_update_fields && summary.visible_update_fields.indexOf('username') != -1" size="lg" style="margin: 10px" @click="row.toggleDetails(); updating = !updating">
            Update
          </b-button>
          <b-button v-else-if="!standalone || summary.visible_update_fields" size="sm" @click="get_vehicle_info_history(row.item); row.toggleDetails();">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="background-color: white; text-align: left;">

            <div v-if="summary.visible_update_fields">
              <b>Add New Status Record</b>
              <div class="row" style="font-weight: bold; margin: 5px">
                <div v-if="standalone" style="padding: 5px; margin: 5px" class="d-flex align-items-center justify-content-center">Username:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.username"/></div>
                <div style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Status:&nbsp;&nbsp;<b-form-select style="width: 200px" v-model="row.item.vehicle_status" :options="status_options"/></div>
                <div v-if="summary.visible_update_fields && summary.visible_update_fields.indexOf('odometer') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Odometer:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.odometer"/></div>
                <div v-if="summary.visible_update_fields && summary.visible_update_fields.indexOf('fuel_level') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Fuel:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.fuel_level"/></div>
                <div v-if="summary.visible_update_fields && summary.visible_update_fields.indexOf('def_level') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">DEF:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.def_level"/></div>
                <div v-if="summary.visible_update_fields && summary.visible_update_fields.indexOf('dump_date') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Dump:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.dump_date"/></div>
                <div v-if="summary.visible_update_fields && summary.visible_update_fields.indexOf('detailed_date') != -1" style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Detailed:&nbsp;&nbsp;<b-form-checkbox size="lg" v-model="row.item.detailed_date"/></div>
                <div style="padding: 15px; margin: 5px" class="d-flex align-items-center justify-content-center">Notes:&nbsp;&nbsp;<b-form-input style="width: 150px" v-model="row.item.notes"/></div>
                <div style="padding: 15px; margin: 5px"><b-button variant="success" size="md" @click="add_new_status_record(row, row.item)">Save Record</b-button></div><br/>
                <div style="padding: 15px; margin: 5px"><b-button variant="success" size="md" @click="delete_status_record(row, row.item)">Delete Record</b-button></div><br/>
                <b-alert v-model="alert.show" :variant="alert.variant" dismissible fade>
                  {{alert.message}}
                </b-alert>
              </div>
              <hr/>
            </div>
            <span v-if="!standalone && row.item.history && row.item.history.length > 0">
            <b>Status Change History</b>
              <b-table bordered :items="row.item.history" :fields="visibleHistoryFields" :tbody-tr-class="get_history_row_color">
              <template slot="processed_time" slot-scope="row">
                {{row.item.processed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_dirty_time" slot-scope="row">
                {{row.item.last_dirty_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_fueled_time" slot-scope="row">
                {{row.item.last_fueled_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_cleaned_time" slot-scope="row">
                {{row.item.last_cleaned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_washed_time" slot-scope="row">
                {{row.item.last_washed_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_ready_time" slot-scope="row">
                {{row.item.last_ready_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_out_time" slot-scope="row">
                {{row.item.last_out_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="last_returned_time" slot-scope="row">
                {{row.item.last_returned_time | formatDateTimeCustom(summary.datetime_format)}}
              </template>
              <template slot="notes" slot-scope="row">
                <div style="margin:3px; text-align: left">{{row.item.notes}}</div>
              </template>
              <template slot="dump_date" slot-scope="row">
                {{row.item.dump_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>

              <template slot="detailed_date" slot-scope="row">
                {{row.item.detailed_date | formatDateTimeCustom(summary.datetime_format)}}
              </template>


            </b-table>
            </span>
          </b-card>
        </template>
      </b-table>
      <b-row v-if="!standalone && items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import {delete_vehicle_status, get_vehicle_info_history, update_vehicle_status, update_vehicle_status_anonymous} from '../networking/apis'
import {get_tbn_vehicle_info, tbn_update_vehicle_status} from "../networking/tbn_apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';

export default {
  name: 'vehicle_status_tbn',
  components: {
     datetime
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      search_filter: '',
      tenant_id: null,
      updating: false,
      standalone: false,
      mode: '',
      washed_enabled: false,
      view_more_info: false,
      update_status_modal: false,
      show_add_vehicle_info_modal: false,
      add_vehicle_info_model: {'manual_record': true},
      columnSelection: false,
      reloading: false,
      reload_mode: 0,
      timer: null,
      items: [],
      items_full: [],
      summary: null,
      loading: true,
      selected_vehicle_statuses: [],
      selected_base: '',
      selected_vehicle_tag: '',
      base_options: [],
      vehicle_tag_options: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      status_options: [
        { value: '', text: 'ALL' },
        { value: 'READY', text: 'READY' },
        { value: 'CLEANED', text: 'CLEANED' },
        { value: 'WASHED', text: 'WASHED' },
        { value: 'DIRTY', text: 'DIRTY' },
        { value: 'OUT', text: 'OUT' },
        { value: 'OOS', text: 'OOS' },
      ],
      reload_options: [
        { value: 0, text: 'OFF' },
        { value: 30000, text: '30s' },
        { value: 60000, text: '1m' },
        { value: 300000, text: '5m' },
      ],
      fields: [
        { key: 'delete', label: '', sortable: false, visible: true, thStyle: { width: "30px" }},
        { key: 'details', label: '', sortable: false, visible: true, thStyle: { width: "30px" }},
        { key: 'name', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'vehicle_status', label:'Status', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'vehicle_tags', label:'Tags', sortable: true, visible: true},
        { key: 'current_mvmt_id', label: 'Current ID', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'current_start_base', label: 'Current Start', sortable: true, visible: true},
        { key: 'current_finish_base', label: 'Current Finish', sortable: true, visible: true},
        { key: 'current_mvmt_return_time', label: 'Current Return', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_fueled_time', label:'Last Fueled', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'last_dirty_time', label:'Dirty Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_time', label:'Cleaned Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true, visible: true},
        { key: 'last_washed_time', label:'Washed Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_washed_number', label:'Washed #', sortable: true, visible: true},
        { key: 'last_ready_time', label:'Ready Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_returned_time', label: 'Last Returned Time', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'dump_date', label:'Dump Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'detailed_date', label:'Detailed Date', visible: false, sortable: true},
        { key: 'next_mvmt_start_base', label: 'Next Start', sortable: true, visible: true, thStyle: { width: "150px" } },
        { key: 'next_mvmt_driver', label: 'Next Driver', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_driver_start', label: 'Next Driver Start', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_id', label: 'Next Booking ID', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_booking_category', label: 'Booking Category', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_scheduled_time', label:'Scheduled Time', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'next_mvmt_time', label:'Next Departure', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'next_mvmt_delta', label:'Departs In', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'odometer', label:'Odometer', visible: false, sortable: true},
        { key: 'fuel_level', label:'Fuel', visible: false, sortable: true},
        { key: 'def_level', label:'DEF', visible: false, sortable: true},
        { key: 'fleetio_status', label:'Fleetio Status', sortable: true, thStyle: { width: "160px" }},
        { key: 'rta_status', label:'RTA Status', sortable: true, thStyle: { width: "160px" }},
        { key: 'rta_work_order_status', label:'RTA WO Status', sortable: true, thStyle: { width: "180px" }},
        { key: 'notes', label: 'Notes', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'update_status', label: '', sortable: false, visible: true, thStyle: { width: "200px" }},
      ],
      history_fields: [
        { key: 'processed_time', label:'Last Updated', visible: true, sortable: true},
        { key: 'updated_by', label:'Updated By', visible: true, sortable: true},
        { key: 'vehicle_status', label:'Status', visible: true, sortable: true},
        { key: 'last_fueled_time', label:'Last Fueled', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_time', label:'Cleaned Time', visible: true, sortable: true},
        { key: 'last_cleaned_number', label:'Cleaned #', visible: true, sortable: true},
        { key: 'last_washed_time', label:'Washed Time', visible: true, sortable: true},
        { key: 'last_washed_number', label:'Washed #', visible: true, sortable: true},
        { key: 'last_ready_time', label:'Ready Time', visible: true, sortable: true},
        { key: 'last_returned_time', label: 'Returned Time', sortable: true, visible: true},
        { key: 'next_scheduled_time', label:'Scheduled Time', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'odometer', label:'Odometer', visible: false, sortable: true},
        { key: 'fuel_level', label:'Fuel', visible: false, sortable: true},
        { key: 'def_level', label:'DEF', visible: false, sortable: true},
        { key: 'notes', label: 'Notes', visible: true, sortable: true},
      ]
    }
  },
  async created() {
    this.fields_all = this.fields
    await this.check_features()
  },
  mounted() {
    this.stopTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.stopTimer()
      if (this.reload_mode > 0) {
        this.timer = setInterval(() => this.reload_data(), this.reload_mode)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },

    printPage() {
      window.print();
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    isTablet() {
      if(/iPad/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      return false;
    },
    async update_fueled_time(row, item, last_fueled_time) {
      if (this.reloading)
        return;

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'last_fueled_time':  last_fueled_time,
        }

        const {value: { data = [] } } = await tbn_update_vehicle_status(this.tenant_id, json)

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },

    async check_features() {

      if (this.$route.path.indexOf('/vsm-tbn/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else if (this.$route.path.indexOf('/vsm-tbn/reload/') != -1) {
        this.standalone = true
        let filter = this.$route.path.split('/vsm-tbn/reload/')[1]

        if (filter.indexOf('/') != -1) {
          this.tenant_id = filter.split("/")[0];
          this.selected_base = filter.split("/")[1];
        } else {
          this.tenant_id = filter;
        }

        this.reload_mode = 60000
      }

      this.fields = this.fields_all
      if (this.standalone)
        this.fields = this.fields.filter(item => (item.key != 'details'))
      else
        this.fields = this.fields.filter(item => (item.key != 'update_status'))

      if (this.isMobile())
        this.fields = this.fields.filter(item => (item.key == 'name' || item.key == 'vehicle_status' || item.key == 'next_mvmt_delta'))

      if (this.isTablet())
        this.fields = this.fields.filter(item => (item.key != 'current_mvmt_return_time' && item.key != 'last_ready_time' && item.key != 'next_mvmt_start_base' && item.key != 'next_mvmt_id'))

      this.load_data()
    },
    async update_vehicle_status(row, item) {
      this.updating = true
      try {

        let json = {
          'name': item.name,
          'vehicle_status':  item.vehicle_status,
          'next_scheduled_time':  item.next_scheduled_time,
        }

        const {value: { data = [] } } = await tbn_update_vehicle_status(this.tenant_id, json)

        //update any caclulated fields that might have changed during the save
        if (data.vehicle_status)
          item.vehicle_status = data.vehicle_status
        if (data.dump_date)
          item.dump_date = data.dump_date
        if (data.detailed_date)
          item.detailed_date = data.detailed_date

        if (row.detailsShowing)
          row.toggleDetails();

        // if (item.next_scheduled_time) {
        //   console.log("item.next_scheduled_time1:" + item.next_scheduled_time)
        //   item.next_scheduled_time = moment(item.next_scheduled_time, 'MM/DD/YYYY H:mm').format('MM/DD/YYYY h:mm a')
        //   console.log("item.next_scheduled_time2:" + item.next_scheduled_time)
        // }

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async add_vehicle_info_record() {
      this.updating = true
      try {
        await update_vehicle_status(this.tenant_id, this.add_vehicle_info_model)
        this.add_vehicle_info_model = {'manual_record': true}
        this.show_add_vehicle_info_modal = false
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
      //this.reload_data()
    },
    async delete_status_record(row, selected_item) {
      this.updating = true
      try {
        if(confirm("Do you really want to delete status record for " + selected_item.name + "?")) {
          const {value: {data = []}} = await delete_vehicle_status(this.tenant_id, selected_item)
          this.items = this.items.filter(item => item.name != selected_item.name)
        }
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async add_new_status_record(row, item) {
      this.updating = true
      try {
        if (this.standalone) {
          try {
            if (this.summary.visible_update_fields.indexOf('username') == -1)
              item.username = 'anonymous'

            const {value: {data = []}} = await update_vehicle_status_anonymous(this.tenant_id, item)
            if (data.vehicle_status)
              item.vehicle_status = data.vehicle_status
            if (data.dump_date)
              item.dump_date = data.dump_date
            if (data.detailed_date)
              item.detailed_date = data.detailed_date
            if (data.wrapped_date)
              item.wrapped_date = data.wrapped_date

          } catch(e){
            this.showAlert("unable to save new status record, invalid username", 'danger', 5000)
            return;
          }
        } else {
          const {value: {data = []}} = await update_vehicle_status(this.tenant_id, item)
          if (data.vehicle_status)
            item.vehicle_status = data.vehicle_status
          if (data.dump_date)
            item.dump_date = data.dump_date
          if (data.detailed_date)
            item.detailed_date = data.detailed_date
          if (data.wrapped_date)
            item.wrapped_date = data.wrapped_date
          if (data.last_cleaned_time)
            item.last_cleaned_time = data.last_cleaned_time
          if (data.last_washed_time)
            item.last_washed_time = data.last_washed_time
          if (data.last_bathroom_cleaned_time)
            item.last_bathroom_cleaned_time = data.last_bathroom_cleaned_time
          if (data.last_def_filled_time)
            item.last_def_filled_time = data.last_def_filled_time
          if (data.last_diesel_filled_time)
            item.last_diesel_filled_time = data.last_diesel_filled_time
        }

        if (this.summary.visible_update_fields.indexOf('username') != -1)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_tbn_vehicle_info(this.tenant_id, this.selected_base, this.selected_vehicle_tag, this.mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.base_options = data.summary.bases
        this.vehicle_tag_options = data.summary.vehicle_tags
        this.washed_enabled = this.summary.washed_enabled
        if (!this.washed_enabled)
          this.status_options = this.status_options.filter(item => (item.value != 'READY' && item.value != 'WASHED'))

        this.filter_items()

        this.stopTimer()
        if (this.reload_mode > 0) {
          this.startTimer()
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async reload_data() {
      try {
        if (this.updating)
          return;

        if (this.$pageVisibility && this.$pageVisibility.hidden)
          return;

        if (this.reloading)
          return;

        this.reloading = true

        var results = await get_tbn_vehicle_info(this.tenant_id, this.selected_base, this.selected_vehicle_tag, this.mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.base_options = data.summary.bases
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    async update_notes(row, item) {
      this.updating = true
      try {
        let json = {
          'name': item.name,
          'notes': item.notes,
        }

        const {value: { data = [] } } = await tbn_update_vehicle_status(this.tenant_id, json)
        if (row.detailsShowing)
          row.toggleDetails();
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async get_vehicle_info_history(selected_item) {
      const {value: { data = [] } } = await get_vehicle_info_history(this.tenant_id, selected_item.name)
      var history_item = this.items_full.filter(item => item.name == selected_item.name)[0]
      history_item.history = data
      this.$forceUpdate()
    },
    filter_by_status(status) {
      if (status == null) {
        this.selected_vehicle_statuses = []
      } else if (this.selected_vehicle_statuses.includes(status)) {
        this.selected_vehicle_statuses = this.selected_vehicle_statuses.filter(s => s !== status)
      } else {
        this.selected_vehicle_statuses = [...this.selected_vehicle_statuses, status]
      }
      this.filter_items()
    },
    filter_items(status) {
      this.items = this.items_full
      if (this.selected_vehicle_statuses.length > 0) {
        const upper = this.selected_vehicle_statuses.map(s => s.toUpperCase())
        this.items = this.items.filter(item => upper.includes(item.vehicle_status))
      }
      if (this.selected_vehicle_tag) {
        this.items = this.items.filter(item => this.contains(item.vehicle_tags,this.selected_vehicle_tag))
      }
      if (status) {
        this.items = this.items.filter(item => item.vehicle_status == status)
      }
      if (this.search_filter != '') {
        this.items = this.items.filter(item => (this.contains(item.start_bases, this.search_filter) || this.contains(item.next_mvmt_driver, this.search_filter) || this.contains(item.name, this.search_filter) || this.contains(item.notes, this.search_filter)))
      }
    },
    get_filter_counts(status) {
      let items_tmp = this.items_full
      if (status) {
        items_tmp = items_tmp.filter(item => item.vehicle_status == status)
      }
      if (this.search_filter != '') {
        items_tmp = items_tmp.filter(item => (this.contains(item.start_bases, this.search_filter) || this.contains(item.name, this.search_filter)))
      }
      return items_tmp.length
    },

    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    get_row_color(item) {
      if (item) {
        if (item.vehicle_status)
          return item.vehicle_status.toLowerCase()
        else
          return "unknown";
      }
    },
    get_history_row_color(item) {
      return "unknown";
    },
},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.isMobile() && this.summary.visible_mobile_fields)
        custom_fields = this.summary.visible_mobile_fields;
      else if (this.summary && this.standalone && this.summary.visible_standalone_fields)
        custom_fields = this.summary.visible_standalone_fields;
      else if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (this.standalone && !this.summary.visible_update_fields) {
        this.fields_all = this.fields_all.filter(item => (item.key != 'details'))
        this.fields = this.fields.filter(item => (item.key != 'details'))
      }

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },
    visibleHistoryFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_history_fields)
        custom_fields = this.summary.visible_history_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.history_fields.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.history_fields
    },
    ready_cnt() {
      return this.get_filter_counts('READY')
    },
    clean_cnt() {
      return this.get_filter_counts('CLEANED')
    },
    washed_cnt() {
      return this.get_filter_counts('WASHED')
    },
    dirty_cnt() {
      return this.get_filter_counts('DIRTY')
    },
    out_cnt() {
      return this.get_filter_counts('OUT')
    },
    oos_cnt() {
      return this.get_filter_counts('OOS')
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_base(val) {
      this.load_data()
    },
    search_filter(val) {
      this.filter_items()
    },
    selected_vehicle_tag(val) {
      this.filter_items()
    },
    reload_mode(val) {
      this.stopTimer()
      if (val > 0)
        this.startTimer()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>

<style scoped>
.total { border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}

.cleaned { background-color: hsla(190,70%,50%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.washed { background-color: hsla(160,30%,40%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.ready { background-color: hsla(120,100%,75%,0.3); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.oos { background-color: hsla(357,78%,65%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.dirty { background-color: hsla(25,28%,23%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.out { background-color: hsla(290,60%,70%,0.3); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}

.unknown td { background-color: white !important;}
.cleaned td { background-color: hsla(190,70%,50%,0.4); border: 1px solid black !important;}
.washed td { background-color: hsla(160,30%,40%,0.4); border: 1px solid black !important; }
.ready td { background-color: hsla(120,100%,75%,0.3); border: 1px solid black !important; }
.oos td { background-color: hsla(357,78%,65%,0.4); border: 1px solid black !important; }
.dirty td { background-color: hsla(25,28%,23%,0.4); border: 1px solid black !important; }
.out td { background-color: hsla(290,60%,70%,0.3); border: 1px solid black !important; }

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

.stats { border-radius: 5px; margin:2px}
</style>

